import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class RegionService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }

    getRegion() {
        return this.http.get(this.global.httpUrl+"regions");
    }

    getRegionById(id: any) {
        return this.http.get(this.global.httpUrl+"regions/"+id);
    } 

    createRegion(data: any){
        return this.http.post(this.global.httpUrl+"regions", data); 
    }

    updateRegion(data: any,id: any){
        return this.http.put(this.global.httpUrl+"regions/"+id, data); 
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/regions/region.service.ts